import { AUTO_FIT } from "./constants";
import {
  isDateFormat,
  isEmptyExportValue,
  trimTrailingDecimalZeros,
} from "./values";

/**
 * Updates the running maximum character width for a column.
 */
export function recordColumnWidth(maxWidthByCol, colNumber, length) {
  if (!length) return;
  maxWidthByCol.set(
    colNumber,
    Math.max(maxWidthByCol.get(colNumber) ?? 0, length)
  );
}

/**
 * Length of the formatted text Excel will display (value + numFmt).
 */
export function getFormattedTextLength(cell) {
  return String(cell.text ?? "").trim().length;
}

/**
 * Length of data-export-raw-value after trimming trailing decimal zeros.
 */
export function getRawValueLength(td) {
  const raw = td.getAttribute("data-export-raw-value");
  if (raw == null || raw === "") return 0;
  return trimTrailingDecimalZeros(raw).length;
}

/**
 * Estimated column width for a body cell (formatted vs raw; dates use raw + padding).
 */
export function getCellWidthLength(cell, td) {
  if (isEmptyExportValue(cell.value)) return 0;

  const formattedLen = getFormattedTextLength(cell);
  const format = td.getAttribute("data-export-type");

  if (isDateFormat(format)) {
    return getRawValueLength(td) + 10;
  }

  return Math.max(formattedLen, getRawValueLength(td));
}

/**
 * Estimated column width for a header cell from display text and value length.
 */
export function getHeaderWidthLength(cell, value) {
  const displayLen = String(cell.text ?? value ?? "").trim().length;
  const valueLen = value ? String(value).length : 0;
  return Math.max(displayLen, valueLen);
}

/**
 * Applies AUTO_FIT min/max/padding to worksheet columns from collected widths.
 */
export function applyColumnWidths(worksheet, maxWidthByCol) {
  const { MIN_WIDTH, MAX_WIDTH, PADDING } = AUTO_FIT;

  maxWidthByCol.forEach((maxLength, colNumber) => {
    worksheet.getColumn(colNumber).width = Math.min(
      Math.max(maxLength + PADDING, MIN_WIDTH),
      MAX_WIDTH
    );
  });
}
